import React from "react";
import { utils_tool, component_tool, framework_tool } from "@/tool";
import getColumns from './columns'
const { WizContainer } = framework_tool;
const { WizDataTable, WizCard  } = component_tool;
const { getPageData } = utils_tool

class Table extends WizContainer {
  componentName = "Table";
  
  constructor(props) {
    super(props);
    this.state = {
      visible: false, 
      record: {}, 
      value: []
    };
  }

  componentDidMount() {
    const { messageEvent } = this.props
    messageEvent.on('showTable',() => {
        this.setState({
            visible: true,
            value: [
              { id: 1, name: 'xiaohuangmao', password: 'sdfasdfas21' },
              { id: 2, name: 'fgfdgdfg', password: 'rt3454ttt' },
              { id: 3, name: 'ewrqwqr', password: '34345erdfd' },
              { id: 4, name: '334tregdggd', password: 'rtyrettrewt3' },
              { id: 5, name: 'vbcnrtrwty', password: '45yrtfrh' },
            ]
        })
    })
    .on('hideTable', _ => {
      this.setState({
        visible: false
      })
    })
  }

  _render() {
    const { messageEvent} = this.props
    const { value, visible, record } = this.state;

    const columns = getColumns()
    
    const dataItems = getPageData({ records: value })
    
    const dataTableProps = { 
        columns, 
        rowKey: 'id', 
        dataItems, 
        selectType: 'checkbox',
        onSelect: (keys, rows) => {
            messageEvent.emit('tableSelectRows',rows)
        }
     }


    return visible ? 
        <WizCard title="数据表格">
            <WizDataTable {...dataTableProps} /> 
        </WizCard>
    : null
  }
}

export default Table;
